import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromFieldWorkerState from './field-worker.reducer';
import * as JobSelectors from '../../../job-detail/+state/job-detail.selectors';

export const selectFieldWorkerState = createFeatureSelector<
	fromFieldWorkerState.FieldWorkerState
>(fromFieldWorkerState.fieldWorkerStoreName);

export const selectFieldWorkerSearchText = createSelector(
	selectFieldWorkerState,
	(fieldWorkerState) => fieldWorkerState.searchText
);

export const selectOnlyAvailableRwics = createSelector(
	selectFieldWorkerState,
	(fieldWorkerState) => fieldWorkerState.onlyAvailableRwics
);

export const selectSelectedTeamId = createSelector(
	selectFieldWorkerState,
	(fieldWorkerState) => fieldWorkerState.selectedTeamId
);

export const selectAllFieldWorkers = createSelector(
	selectFieldWorkerState,
	fromFieldWorkerState.selectAll
);

export const selectAllRwicFieldWorkers = createSelector(
	selectAllFieldWorkers,
	(fieldWorkerState) =>
		fieldWorkerState.filter((fw) => {
			return (
				fw.type.id === 0 ||
				fw.type.id === 1 ||
				fw.type.id === 2 ||
				fw.type.id === 3
			);
		})
);

export const selectFilteredRwicFieldWorkers = createSelector(
	selectAllRwicFieldWorkers,
	selectFieldWorkerSearchText,
	selectSelectedTeamId,
	JobSelectors.getSelectedJob,
	(fieldWorkers, searchText, teamId, _job) =>
		fieldWorkers
			.filter((fw) => (teamId.length ? fw.team && teamId.includes(fw.team.id) : true))
			.filter((fw) => {
				const name = fw.firstName.toLowerCase();
				if (!searchText) {
					return true;
				}
				const res = name.includes(searchText.toLowerCase());
				return res;
			})
);

export const selectFieldWorkersLoading = createSelector(
	selectFieldWorkerState,
	(fieldWorkerState) => fieldWorkerState.loading
);

export const selectFieldWorkerId = (fieldWorkerId: number) =>
	createSelector(
		selectFieldWorkerState,
		(fieldWorkerState) => fieldWorkerState.entities[fieldWorkerId]
	);
